const ICON_SRCS: Record<string, string> = {
  star: '/icons/star.png',
  coins: '/icons/coins.png'
}

export type GameIconName = keyof typeof ICON_SRCS

export type GameIconProps = {
  name: GameIconName
  size?: number
  className?: string
  alt?: string
}

export const GameIcon = ({ name, size = 16, className, alt = '' }: GameIconProps) => (
  <img
    src={ICON_SRCS[name]}
    alt={alt}
    width={size}
    height={size}
    className={className}
    style={{ objectFit: 'contain', display: 'inline-block', verticalAlign: 'middle' }}
  />
)

GameIcon.displayName = 'GameIcon'
